import { render, staticRenderFns } from "./organizationusers.vue?vue&type=template&id=63bf526f"
import script from "./organizationusers.vue?vue&type=script&lang=js"
export * from "./organizationusers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports